export default __webpack_public_path__ + "static/media/planet3.a39a2e38.webp";